<script setup lang="ts">
import { $t } from '../../../../composables/i18n'
import PFloatingPanelDialog from '../../../dialog/PFloatingPanelDialog.vue'

const isOpen = defineModel<boolean>()
</script>

<template>
  <p-floating-panel-dialog
    v-model="isOpen"
    :title="$t('Settings')"
    cy="setting-mobile-menu-dialog"
    @close="isOpen = false"
  >
    <slot name="default" />
  </p-floating-panel-dialog>
</template>
